import { render, staticRenderFns } from "./InjuryTypeCards.vue?vue&type=template&id=65c867ff&"
import script from "./InjuryTypeCards.vue?vue&type=script&lang=js&"
export * from "./InjuryTypeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports